<div class="data-preview-outer-wrapper">

    <div *ngIf="inlineMode" class="back-to-task-btn" (click)="backToNewTask()">
        <mat-icon>chevron_left</mat-icon> <span>Back to Tasking</span>
    </div>
    <mat-tab-group [(selectedIndex)]="selectedPreviewTab">
        <mat-tab>
            <ng-template mat-tab-label>
                <span matTooltip="The sensor types and sensors on the platform">Sensors</span>
            </ng-template>
            <app-taskcost-sensor-preview
            [showCloseButton]="data?.isDialogBox ?? false"
            [initialSensorType]="sensorTypeFromRoute"
            (closeRequested)="closeDialog()"></app-taskcost-sensor-preview>
        </mat-tab>
        <mat-tab label="TLE">
            <app-tle-preview></app-tle-preview>
        </mat-tab>
        <mat-tab *ngIf="!data?.isDialogBox && !isStarterUser">
            <ng-template mat-tab-label>
                <span matTooltip="The automated extraction of information from sensor data">Feeds</span>
            </ng-template>
            <app-feeds-data-preview></app-feeds-data-preview>
        </mat-tab>
        <mat-tab *ngIf="!data?.isDialogBox">
            <ng-template mat-tab-label>
                <span matTooltip="The mathematical operations on the bands of sensors resulting in usable information">Indices</span>
            </ng-template>
            <app-indices-preview ></app-indices-preview>
        </mat-tab>
    </mat-tab-group>
</div>
